import {
  DisconnectOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  LinkOutlined,
} from '@ant-design/icons'
import {Button, Modal, Select, Slider, Tooltip, message} from 'antd'
import React, {useCallback, useState} from 'react'
import {instance as plantsService} from '../../services/PlantsService'
import {ElementWithVisibility, PlantWithVisibility} from './CanvasViewEditorData'
import {useIntl} from 'react-intl'

export type ElementControlRecordProps = {
  elementName: string
  elementId: number
  isVisible: boolean
  setVisibility: (isVisible: boolean) => void
  isSolitariusTemplate: boolean
  solitariusTemplateElement?: ElementWithVisibility
  plantsList?: PlantWithVisibility[]
  elementsList?: ElementWithVisibility[]
  onConnectPlant?: (solitariusTemplateElement: ElementWithVisibility, plantId: string) => void
  projectId?: number
}

export function ElementControlRecord(props: ElementControlRecordProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()
  const [modalOpen, setModalOpen] = useState(false)
  const [connectedPlant, setConnectedPlant] = useState(null)

  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'row',
        textOverflow: 'ellipsis',
        pointerEvents: 'all',
        flex: '1 1 auto',
      }}
    >
      <span style={{flexGrow: 1, flexShrink: 1}}>
        <span>{props.elementName}</span>
      </span>
      <span style={{flexGrow: 0, flexShrink: 0}}>
        {props.isSolitariusTemplate && (
          <>
            <Tooltip placement="bottom" title={intl.formatMessage({id: 'combineElementWithPlant'})}>
              <Button
                size="small"
                shape="circle"
                icon={<LinkOutlined />}
                type="link"
                onClick={(e) => {
                  setModalOpen(true)
                  e.stopPropagation()
                }}
              ></Button>
            </Tooltip>
            <Modal
              open={modalOpen}
              onOk={async () => {
                if (connectedPlant) {
                  props.onConnectPlant(props.solitariusTemplateElement, connectedPlant.id)

                  setConnectedPlant(null)
                  setModalOpen(false)
                } else {
                  setModalOpen(false)
                }
              }}
              onCancel={() => {
                setConnectedPlant(null)
                setModalOpen(false)
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                style={{paddingRight: '20px'}}
              >
                <span>{intl.formatMessage({id: 'selectPlantForConnection'})}</span>
                <span style={{fontStyle: 'italic', color: 'rgb(244, 130, 84)'}}>
                  {props.solitariusTemplateElement.name}
                </span>
                <span>:</span>
                <Select
                  style={{width: '90%'}}
                  allowClear
                  options={props.plantsList?.map((plant) => ({
                    label: plant.name,
                    value: String(plant.id),
                  }))}
                  onChange={(chosenPlantId) =>
                    setConnectedPlant({
                      id: chosenPlantId,
                      name: props.plantsList.find((plant) => String(plant.id) === chosenPlantId)
                        ?.name,
                    })
                  }
                ></Select>
                <span style={{fontStyle: 'italic'}}>
                  {intl.formatMessage({id: 'selectPlantForConnectionNote'})}.
                </span>
              </div>
            </Modal>
          </>
        )}
        <Tooltip
          placement="bottom"
          title={
            props.isVisible
              ? intl.formatMessage({id: 'hideElementOnSitePlan'})
              : intl.formatMessage({id: 'showElementOnSitePlan'})
          }
        >
          <Button
            size="small"
            shape="circle"
            icon={props.isVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
            type="link"
            onClick={(e) => {
              props.setVisibility(!props.isVisible)
              e.stopPropagation()
            }}
          ></Button>
        </Tooltip>
      </span>
    </div>
  )
}
